/**
 * Created by Tengfei Li on 2026-01-20
 * 未下发配置（未私有化）Tab 组件
 */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Space, Table, Modal, message } from 'antd';
import { SelectItem } from '../../components/select-item';
import { InputItem } from '../../components/inputItem';
import i18n from 'i18next';
import { TablePagination } from '../../components/lib';
import { useTableSelection } from './use-table-selection';
import { http } from '../../common/request';
import { HttpURLS } from '../../common/http-url-define';
import { resultModal } from '../../components/result-modal';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import actions from '../../redux/action';
import _ from 'lodash';

function UnsentDevicesTab(props) {
  const {
    selectedMacs,
    // setSelectedMacs,
    rowSelection,
    clearSelected,
  } = useTableSelection();

  const { language, onRefreshConfigList, onRefreshProducts } = props;

  const [mac, setMac] = useState('');
  const [productCode, setProductCode] = useState(null);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [configDialogVisible, setConfigDialogVisible] = useState(false);

  // 初始化时获取配置列表和产品列表
  useEffect(() => {
    onRefreshConfigList();
    onRefreshProducts(language);
  }, [language, onRefreshConfigList, onRefreshProducts]);

  // 构建搜索 filter
  const buildFilter = useCallback((params = {}) => {
    return _.omitBy({
      hadPrivate: false,
      offset: 0,
      limit: 50,
      keyword: mac || undefined,
      productCode: productCode || undefined,
      ...params,
    }, _.isNil);
  }, [mac, productCode]);

  // 防抖搜索
  const debouncedSearch = useCallback(
    _.debounce(() => {
      props.onRefreshNotPrivateDevices(language, buildFilter());
      clearSelected();
    }, 500),
    [buildFilter, language]
  );

  useEffect(() => {
    debouncedSearch();
    return () => {
      debouncedSearch.cancel();
    };
  }, [mac, productCode, debouncedSearch]);

  const tableColumns = [
    { title: 'MAC', dataIndex: 'mac', key: 'mac' },
    { title: 'SN', dataIndex: 'sn', key: 'sn', render: (text) => text || '-' },
    { title: 'IMEI', dataIndex: 'imei', key: 'imei', render: (text) => text || '-' },
    { title: i18n.t('device_type'), dataIndex: 'name', key: 'name' },
    // { title: i18n.t('current_platform'), dataIndex: 'fromApp', key: 'fromApp' },
    { title: i18n.t('create_time'), dataIndex: 'createAt', key: 'createAt' },
  ];

  const handleSendConfig = () => {
    if (selectedMacs.length === 0) {
      message.warning(i18n.t('select_devices'));
      return;
    }
    setConfigDialogVisible(true);
  };

  const confirmSendConfig = () => {
    if (!selectedConfig) {
      message.warning(i18n.t('select_config'));
      return;
    }
    setIsSending(true);
    http('put', HttpURLS.DEVICE_URL, {
      macList: selectedMacs,
      privateConfigId: selectedConfig.value
    })
      .then(res => {
        const { code } = res.data;
        if (code === 200) {
          setConfigDialogVisible(false);
          props.onRefreshNotPrivateDevices(language, buildFilter());
          resultModal({
            title: i18n.t('send_config_success'),
            subTitle: i18n.t('send_config_success_sub_title').replace('@$', `${selectedMacs.length}`),
            status: 'success',
          });
          clearSelected();
        } else {
          resultModal({
            title: i18n.t('send_config_failed'),
            status: 'error',
          });
        }
      })
      .catch(err => {
        resultModal({
          title: i18n.t('send_config_failed'),
          status: 'error',
        });
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  const refresh = (params) => {
    props.onRefreshNotPrivateDevices(language, buildFilter(params));
  };

  return (
    <div>
      <TipText>* {i18n.t('select_devices2')}</TipText>
      <SearchContainer>
        <Space direction="horizontal">
          <SelectItem
            dropdownMatchSelectWidth={300}
            style={{ marginTop: 0, minWidth: 200 }}
            onChanged={event => {
              setProductCode(event?.value);
            }}
            options={props.products}
            placeholder={i18n.t('select_device_type')}
          />
          <InputItem
            placeholder="MAC/SN"
            bordered={true}
            onChange={event => setMac(event.target?.value)}
            style={{ width: 200 }}
            showSearch={true}
          />
        </Space>
      </SearchContainer>
      <TableContainer>
        <Table
          rowKey={({ mac }) => mac}
          columns={tableColumns}
          rowSelection={rowSelection}
          dataSource={props.deviceList}
          size="small"
          loading={props.loading}
          pagination={false}
          scroll={{ y: document.body.clientHeight - 343 }}
          footer={() => props.deviceList.length > 0 && (
            <FooterContainer>
              <Space direction="horizontal" style={{ marginTop: 5, marginBottom: 5 }}>
                <Button
                  type="primary"
                  disabled={selectedMacs.length === 0}
                  size="middle"
                  onClick={handleSendConfig}
                >
                  {i18n.t('send_config')}
                </Button>
                <label style={{ fontSize: 16 }}>
                  {i18n.t('table_footer').replace('@$', `${selectedMacs.length}`)}
                </label>
              </Space>
              <TablePagination
                total={props.total}
                current={props.currentPage}
                pageSize={props.pageSize}
                refresh={refresh}
              />
            </FooterContainer>
          )}
        />
      </TableContainer>

      <Modal
        width={380}
        title={i18n.t('send_private_mqtt_config')}
        visible={configDialogVisible}
        onCancel={() => setConfigDialogVisible(false)}
        onOk={confirmSendConfig}
        okButtonProps={{ disabled: !selectedConfig }}
        okText={i18n.t('consent')}
        cancelText={i18n.t('cancel')}
        confirmLoading={isSending}
      >
        <label>
          {i18n.t('selected_devices_count').replace('@$', `${selectedMacs.length}`)}
        </label>
        <SelectItem
          options={props.configList}
          style={{ marginTop: 10 }}
          placeholder={i18n.t('select_private_config')}
          onSelect={event => {
            setSelectedConfig(event);
          }}
        />
      </Modal>
    </div>
  );
}

const SearchContainer = styled.div`
  margin-bottom: 16px;
`;


const TipText = styled.div`
  font-size: 12px;
  opacity: 80%;
  margin-bottom: 18px;
`;

const TableContainer = styled.div`
  min-height: 400px;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const mapState2Props = state => {
  return {
    language: state.language.language,
    products: state.config.products,
    deviceList: state.device.notPrivateDeviceList,
    loading: state.device.notPrivateDeviceListLoading,
    total: state.device.notPrivateDeviceListTotal,
    currentPage: state.device.notPrivateDeviceListCurrentPage,
    pageSize: state.device.notPrivateDeviceListPageSize,
    configList: state.config.configList.map(({ id, name }) => ({
      label: name,
      value: id,
    })),
  };
};

const mapDispatch2Props = dispatch => ({
  onRefreshNotPrivateDevices: (language, filter) =>
  dispatch(actions.onRefreshNotPrivateDevices(language, filter)),
  onRefreshConfigList: () => dispatch(actions.onRefreshConfigList()),
  onRefreshProducts: language => dispatch(actions.onRefreshProducts(language)),
});

export default connect(mapState2Props, mapDispatch2Props)(UnsentDevicesTab);
